import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import shiftAndReports from '@/modules/shift-and-reports/store'
import stopList from '@/modules/menu-management/store'
import dispatcher from '@/modules/dispatcher/store'
import foreman from '@/store/foreman'

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import orders from './orders'
import order from './order'
import menu from './menu'
import guest from './guest'
import ticketTime from './ticket-time'
import naumen from './naumen'
import department from './department'
import sessions from './sessions'
import play from './play'
import notes from './notes'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        backLink: '',
        runLink: '',
        statisticsLink: false,
        isForeman: false,
    },
    mutations: {
        SET_BACK_LINK: (state, payload) => {
            state.backLink = payload
        },
        SET_START_LINK: (state, payload) => {
            state.runLink = payload
        },
        IS_STATISTICS: (state, payload) => {
            state.statisticsLink = payload
        },
        IS_FOREMAN: (state, payload) => {
            state.isForeman = payload
        },
    },
    modules: {
        app,
        appConfig,
        verticalMenu,
        orders,
        order,
        menu,
        guest,
        ticketTime,
        naumen,
        department,
        sessions,
        foreman,
        play,
        notes,
        stopList,
        shiftAndReports,
        dispatcher,
    },
    strict: import.meta.env.DEV,
})
